<template>
  <v-app id="app">
    <TopDash />
    <router-view></router-view>
    <Footer />
  </v-app>
</template>

<script>
    import TopDash from './components/TopDash'
    import Footer from './components/Footer'

    export default {
        name: "App",
        components: {
            TopDash,
            Footer
        }
    }
</script>

<style>
  @import url('./common/common.css');
  @import url('./common/ckeditor-content-styles.css');
</style>